import { useMutation } from 'react-query';
import { trpc } from '../../../../lib/trpc';

const useUpdateProductDocSortTemplateProperty = () => {
    return useMutation(async (params: { docs: { id: number }[]; documentable_id: number }) => {
        return trpc.ProductsApi.updateSortBulkTemplateProperty.mutate({
            docs: params.docs,
            entityId: params.documentable_id,
        });
    });
};

export default useUpdateProductDocSortTemplateProperty;
